function InfoCircleContent() {
  return (
    <div className="w-[292px] space-y-4 px-2 py-1">
      <div className="flex flex-col space-y-1">
        <div className="font-medium text-black text-opacity-90">
          Extract from Drawings
        </div>
        <div className="text-ciq-gray-900 text-xs">
          Upload Drawing files to quickly pull out Materials from Schedules.
        </div>
      </div>
      <div className="flex flex-col space-y-1">
        <div className="font-medium text-black text-opacity-90">
          View Source
        </div>
        <div className="text-ciq-gray-900 text-xs">
          Click on a row to view its source in your drawing file.
        </div>
      </div>
      <div className="flex flex-col space-y-1">
        <div className="font-medium text-black text-opacity-90">
          Track in Log
        </div>
        <div className="text-ciq-gray-900  text-xs">
          Select rows to track them in the Material Log.
        </div>
        <ul className="list-disc list-inside mt-1 text-ciq-gray-900 text-xs space-y-1">
          <li>
            <span>Track:</span>
            <div className="italic">creates one Material per selection.</div>
          </li>
          <li>
            <span>Merge &amp; Track:</span>
            <div className="italic">
              combines selections to create one Material.
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default InfoCircleContent;
